import NewIncomingShipmentCard from "./NewIncomingShipmentCard";
export default NewIncomingShipmentCard;
